import { render } from "./OurBlog.vue?vue&type=template&id=fef51382"
import script from "./OurBlog.vue?vue&type=script&lang=js"
export * from "./OurBlog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__